module.exports = __webpack_public_path__ + "static/media/LatrineNeptune_tn.57a73499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/LatrineNeptune_tn.jpg
// module id = 670
// module chunks = 0